import { Navigate, Route, Routes } from "react-router-dom";
import Job from "./module/job/Job";
import JobDetails from "./module/job-details/JobDetails";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Login from "./admin/module/auth/Login";
import AdminLayout from "./admin/AdminLayout";
import JobCategoryList from "./admin/module/job/candidates/JobCateoryList";
import JobList from "./admin/module/job/job-list/JobList";
import ApplicationList from "./admin/module/job/application-list/ApplicationList";
import JobListApplication from "./admin/module/job/application-list/JobListApplication";

import JobCategoryUserApplication from "./admin/module/job/candidates/JobCategoryUserApplication";
import JobListView from "./admin/module/job/job-list/View";
import withAuthenticationRequired from "./shared/utils/withAuthenticationRequired";
import withoutAuthenticationRequired from "./shared/utils/withoutAuthenticationRequired";
import NotFound from "./shared/components/NotFound";
import CreateNewJob from "./admin/module/job/job-list/CreateNewJob";
import UpdateJob from "./admin/module/job/job-list/UpdateJob";
import JobCategoryUser from "./admin/module/job/candidates/JobCategoryUser";
import ClientSideLayout from "./module/ClientSideLayout";
import InvesterLevelThree from "./admin/module/master/level3";
import InvesterLevelTwo from "./admin/module/master/level2";
import InvesterMainTopic from "./admin/module/master/level1";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <Routes>
        <Route path="/" element={<ClientSideLayout />}>
          <Route path="/" element={<Job />} />
          <Route path="job-details/:id" element={<JobDetails />} />
        </Route>
        <Route
          path="/admin/login"
          element={withoutAuthenticationRequired(Login)}
        />
        <Route path="/admin" element={withAuthenticationRequired(AdminLayout)}>
          <Route index element={<Navigate to={"job-category-list"} />} />
          <Route path="job-category-list" element={<JobCategoryList />} />
          <Route
            path="job-category-user/:categoryId"
            element={<JobCategoryUser />}
          />
          <Route
            path="job-category-user-application/:categoryId"
            element={<JobCategoryUserApplication />}
          />

          <Route path="create-new-job" element={<CreateNewJob />} />
          <Route path="update-job/:jobId" element={<UpdateJob />} />

          <Route path="job-list" element={<JobList />} />
          <Route
            path="job-list-application/:jobId"
            element={<JobListApplication />}
          />
          <Route path="application-list" element={<ApplicationList />} />
          <Route path="job-list/view/33" element={<JobListView />} />
          <Route path="level-one" element={<InvesterMainTopic />} />
          <Route path="level-two" element={<InvesterLevelTwo />} />
          <Route path="level-three" element={<InvesterLevelThree />} />
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
      <ToastContainer />
    </QueryClientProvider>
  );
}

export default App;
